export default "__VITE_ASSET__ChALA3uk__"